var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"ui-inline-nft",attrs:{"to":_vm.routerParams}},[_c('img',{staticClass:"ui-inline-nft__image",attrs:{"loading":"lazy","src":_vm.imageSrc}}),_vm._v(" "),_c('div',{staticClass:"ui-inline-nft__title",domProps:{"textContent":_vm._s(_vm.$t('common.nft_item'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }